export function sortByString(a: string, b: string) {
  return a.localeCompare(b);
}

export function sortByNumber(a: number, b: number) {
  return a - b;
}

export function sortByDate(a: Date, b: Date) {
  return a.getTime() - b.getTime();
}

/**
 * Сравнение названий так, как их читает человек: числа внутри — по значению
 * («Приказ 2» перед «Приказ 10»), регистр не разносит одно название.
 */
export function sortByTitle(a: string, b: string) {
  return a.localeCompare(b, undefined, { numeric: true, sensitivity: "base" });
}
